export default __webpack_public_path__ + "static/media/pic13.5dfac231.jpg";